// Portal KPI üst barı (M16 T19) — KpiContextBar'ın müşteri hali: MÜŞTERİ seçici YOK (set erişimi
// kullanıcıya özel), set seçici yalnız birden çok set varsa, yıl aralığı seçici, sağ slot.
// Seçim `portal-kpi-store`'da (kullanıcı bazında localStorage). P1-1: birden çok aktif yaprak
// işletme varsa İŞLETME seçici (yapraklar + "Konsolide (yalnız görüntüleme)") — tablo seçili
// işletmeye daraltılır; tek işletmede seçici yok (eski görünüm birebir).

import { KPI_COPY, yearHeaderLabel } from "../../lib/kpi-ui";
import {
  PORTAL_CONSOLIDATED,
  portalTotalKind,
  portalTotalOptionLabel,
} from "../../lib/portal-kpi-ui";
import { usePortalKpiStore } from "../../stores/portal-kpi-store";

const selectStyle: React.CSSProperties = {
  padding: "6px 10px",
  borderRadius: 8,
  border: "1px solid var(--color-border)",
  background: "var(--color-surface)",
  fontSize: "0.85rem",
  color: "var(--color-text)",
  minWidth: 160,
  minHeight: 36,
};

export function PortalKpiBar({
  showYears,
  showEntity,
  right,
}: {
  showYears?: boolean;
  /** işletme seçici (Veri Girişi / Özet); içe aktarmada yok */
  showEntity?: boolean;
  right?: React.ReactNode;
}): JSX.Element {
  const sets = usePortalKpiStore((s) => s.sets);
  const setId = usePortalKpiStore((s) => s.setId);
  const years = usePortalKpiStore((s) => s.years);
  const entities = usePortalKpiStore((s) => s.entities);
  const entityId = usePortalKpiStore((s) => s.entityId);
  const entityChoice = usePortalKpiStore((s) => s.entityChoice);
  const selectSet = usePortalKpiStore((s) => s.selectSet);
  const selectEntity = usePortalKpiStore((s) => s.selectEntity);
  const setYears = usePortalKpiStore((s) => s.setYears);
  // M17 T5 — mali yıl müşterisinde seçenek metni "MY2026" (value yıl sayısı kalır)
  const fiscalStartMonth = usePortalKpiStore((s) => s.grid?.fiscalYearStartMonth);
  const entityScope = usePortalKpiStore((s) => s.grid?.entityScope);
  const current = sets.find((s) => s.id === setId);
  // Y6 — toplam seçeneğinin etiketi `totalKind`'den: kapsamlı kullanıcıya "Konsolide" yazılmaz
  const totalLabel = portalTotalOptionLabel(
    portalTotalKind(entityScope ? { entityScope } : null, current),
  );
  const leaves = entities
    .filter((e) => e.isActive && !entities.some((c) => c.parentId === e.id && c.isActive))
    .sort((a, b) => a.orderIndex - b.orderIndex);

  const yearOptions: number[] = [];
  const now = new Date().getFullYear();
  for (let y = now - 9; y <= now + 1; y += 1) yearOptions.push(y);

  function range(from: number, to: number): number[] {
    const out: number[] = [];
    for (let y = Math.min(from, to); y <= Math.max(from, to); y += 1) out.push(y);
    return out;
  }

  return (
    <div
      className="flex items-center gap-3 flex-wrap rounded-xl px-3 py-2 mb-4"
      style={{ background: "var(--color-surface)", border: "1px solid var(--color-border)" }}
    >
      {sets.length > 1 ? (
        <label className="flex items-center gap-2 text-sm" style={{ color: "var(--color-text-2)" }}>
          {KPI_COPY.portal.setLabel}
          <select
            aria-label={KPI_COPY.portal.setLabel}
            style={selectStyle}
            value={setId ?? ""}
            onChange={(e) => void selectSet(e.target.value || null)}
          >
            {sets.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name} · {s.indicatorCount} gösterge
              </option>
            ))}
          </select>
        </label>
      ) : current ? (
        <span className="text-sm" style={{ color: "var(--color-text-2)" }}>
          {KPI_COPY.portal.setLabel}: <b style={{ color: "var(--color-text)" }}>{current.name}</b>
        </span>
      ) : null}
      {showEntity && setId && entityChoice ? (
        <label className="flex items-center gap-2 text-sm" style={{ color: "var(--color-text-2)" }}>
          {KPI_COPY.portal.entityLabel}
          <select
            aria-label={KPI_COPY.portal.entityLabel}
            data-testid="portal-entity-select"
            style={selectStyle}
            value={entityId ?? ""}
            onChange={(e) => void selectEntity(e.target.value)}
          >
            {leaves.map((e) => (
              <option key={e.id} value={e.id}>
                {e.name}
              </option>
            ))}
            <option value={PORTAL_CONSOLIDATED}>{totalLabel}</option>
          </select>
        </label>
      ) : null}
      {showYears && setId ? (
        <fieldset
          className="flex items-center gap-1 text-sm"
          style={{ border: 0, padding: 0, margin: 0, color: "var(--color-text-2)" }}
        >
          <legend className="sr-only">{KPI_COPY.yearsLabel}</legend>
          <span>{KPI_COPY.yearsLabel}</span>
          <select
            aria-label="Başlangıç yılı"
            style={{ ...selectStyle, minWidth: 90 }}
            value={years[0]}
            onChange={(e) => void setYears(range(Number(e.target.value), years[years.length - 1]!))}
          >
            {yearOptions.map((y) => (
              <option key={y} value={y}>
                {yearHeaderLabel(y, fiscalStartMonth)}
              </option>
            ))}
          </select>
          <span>–</span>
          <select
            aria-label="Bitiş yılı"
            style={{ ...selectStyle, minWidth: 90 }}
            value={years[years.length - 1]}
            onChange={(e) => void setYears(range(years[0]!, Number(e.target.value)))}
          >
            {yearOptions.map((y) => (
              <option key={y} value={y}>
                {yearHeaderLabel(y, fiscalStartMonth)}
              </option>
            ))}
          </select>
        </fieldset>
      ) : null}
      <span style={{ flex: 1 }} />
      {right}
    </div>
  );
}
